import React, { useContext, useEffect, useState } from "react";
import { SettingsBannerContext } from "../../../contexts/SettingsBannerContext";
import { MasterBannerContext } from "../../../contexts/MasterBannerContext";
import Divider from "@mui/material/Divider";
import { Compress, GetBannerSize, resizedataURL } from "../../../helpers/fileManager";
import "./index.css";
import { ConvertBanner } from "../../../helpers/exportBanner";
import { ChromePicker } from "react-color";
import { Switch } from "@mui/material";

function Properties() {
  const { setReload, setLoading, backupFormat, setBackupFormat } = useContext(
    SettingsBannerContext
  );
  const { master, setMaster } = useContext(MasterBannerContext);
  const [newKbValue, setNewKbValue] = useState("");
  const [border, setBorder] = useState(true);
  const [openColor, setOpenColor] = useState(false);
  const [blockPickerColor, setBlockPickerColor] = useState("");

  function changeBackground(bg) {
    let masterCopy = { ...master };
    setBlockPickerColor();
    masterCopy.backgroundColor = bg;
    setMaster(masterCopy);
    setReload(true);
    return;
  }

  function addOrRemoveBorder(border) {
    let masterCopy = { ...master };
    let borderBlack = "solid 0.75px  #aeaeae";

    if (border === true) {
      masterCopy.bannerBorder = "none";
      setBorder(false);
    } else {
      masterCopy.bannerBorder = borderBlack;
      setBorder(true);
    }
    setMaster(masterCopy);
    setReload(true);
    return;
  }

  async function ChangeOptimize(item) {
    try {
      setLoading({ show: true, progress: false });
      let masterCopy = { ...master };
      masterCopy.optimize = item;
      var b64 = "";
      for (var i = 0; i < master.elements.length; i++) {
        if (!master.elements[i].properties.originalBackground) continue;
        var originalBG = master.elements[i].properties.originalBackground;
        if (master.elements[i].reduce) {
          originalBG = await resizedataURL(originalBG, master.elements[i].properties.width * master.elements[i].properties.scale / 100, master.elements[i].properties.height * master.elements[i].properties.scale / 100);
        }
        if (item < 100) {
          b64 = await Compress(
            originalBG,
            masterCopy.optimize
          );
          masterCopy.elements[i].properties.background = b64;
        } else {
          b64 = originalBG;
          masterCopy.elements[i].properties.background = b64;
        }
      }
      let html = await ConvertBanner(masterCopy);
      console.log(html)
      let getSize = await parseInt(GetBannerSize(html));
      console.log('getSize')
      console.log(getSize)
      masterCopy.size = getSize;      
      setMaster(masterCopy);
      setReload(true);
      setLoading({ show: false, progress: false });
    } catch (error) {
      setLoading({ show: false, progress: false });
    }
    return;
  }

  async function MinMaxOptimize(value) {
    try {
      setLoading({ show: true, progress: false });
      let masterCopy = { ...master };
      masterCopy.optimize = value;
      var b64 = "";
      for (var i = 0; i < master.elements.length; i++) {
        if (!master.elements[i].properties.originalBackground) continue;
        var originalBG = master.elements[i].properties.originalBackground;
        if (master.elements[i].reduce) {
          originalBG = await resizedataURL(originalBG, master.elements[i].properties.width * master.elements[i].properties.scale / 100, master.elements[i].properties.height * master.elements[i].properties.scale / 100);
        }
        if (value < 100) {
          b64 = await Compress(
            originalBG,
            masterCopy.optimize
          );
          masterCopy.elements[i].properties.background = b64;
        } else {
          b64 = originalBG;
          masterCopy.elements[i].properties.background = b64;
        }
      }
      setSelectedValue(masterCopy.optimize);
      setMaster(masterCopy);
      setReload(true);
      setLoading({ show: false, progress: false });
    } catch (error) {
      setLoading({ show: false, progress: false });
    }
  }

  async function ResizeKb(value) {
    if (!value) return;
    try {
      setLoading({ show: true, progress: false });
      let masterCopy = { ...master };
      const KbOptimizeValue = value;
      let b64 = "";
      for (var i = 10; i > 0; i--) {
        masterCopy.optimize = i * 10;
        for (var j = 0; j < master.elements.length; j++) {
          if (!master.elements[j].properties.originalBackground) continue;
          var originalBG = master.elements[j].properties.originalBackground;
          if (master.elements[i].reduce) {
            originalBG = await resizedataURL(originalBG, master.elements[j].properties.width * master.elements[j].properties.scale / 100, master.elements[j].properties.height * master.elements[j].properties.scale / 100);
          }
          if (masterCopy.optimize === 100) {
            masterCopy.elements[j].properties.background = originalBG;
          } else {
            b64 = await Compress(
              originalBG,
              masterCopy.optimize
            );
            masterCopy.elements[j].properties.background = b64;
          }
        }
        let html = await ConvertBanner(masterCopy);
        console.log('html')
        console.log(html)
        let getSize = await parseInt(GetBannerSize(html));
        masterCopy.size = getSize;
        if (getSize <= KbOptimizeValue) break;
      }
      setNewKbValue("");
      setSelectedValue(masterCopy.optimize);
      setMaster(masterCopy);
      setReload(true);
      setLoading({ show: false, progress: false });
    } catch (error) {
      console.log("error");
      console.log(error);
      setLoading({ show: false, progress: false });
    }
  }

  const [collapsedFormatDiv, setCollapsedFormatDiv] = useState(false);

  const handleCollapseFormat = () => {
    setCollapsedFormatDiv(!collapsedFormatDiv);
  };

  const [selectedValue, setSelectedValue] = useState("");

  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    ChangeOptimize(newValue);
    setSelectedValue(newValue);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      ResizeKb(newKbValue);
      event.target.blur();
    }
  };

  let currentBg = "";
  let currentBorder = "";
  if (master && master.backgroundColor) {
    currentBg = master.backgroundColor.trim().toUpperCase();
  } else {
    currentBg = "#FFF";
  }
  if (master && master.bannerBorder) {
    currentBorder = master.bannerBorder.trim().toUpperCase();
  }

  function openCloseColorPick() {
    openColor === true ? setOpenColor(false) : setOpenColor(true);
    setBlockPickerColor(master.backgroundColor);
  }

  useEffect(() => {
    setSelectedValue(master.optimize);
    setBlockPickerColor(currentBg);
  }, [master]);

  return (
    <div className="mainProperties">
      <div className="propertiesTitleAndArrow">
        <span
          style={{
            color: "#222222",
            fontWeight: "bold",
            fontSize: "16px",
            margin: "0 0 -5px 1px",
          }}
        >
          Formato
        </span>
        {collapsedFormatDiv ? (
          <img
            src="assets/arrownew.png"
            className="stepNumberArrowUp"
            onClick={handleCollapseFormat}
            style={{
              transform: "rotate(180deg)",
              padding: "5px",
              cursor: "pointer",
              width: "11px",
              height: "7px",
              margin: "10px 0 0 0",
            }}
          />
        ) : (
          <img
            src="assets/arrownew.png"
            className="stepNumberArrowUp"
            onClick={handleCollapseFormat}
            style={{
              padding: "5px",
              cursor: "pointer",
              width: "11px",
              height: "7px",
              margin: "10px 0 0 0",
            }}
          />
        )}
      </div>
      <Divider className="propertiesDividerTitle" />
      {!collapsedFormatDiv ? (
        <div className="propertiesContent">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "30px",
              marginTop: "5px",
            }}
          >
            <div style={{ fontSize: "16px", color: "#707070" }}>Largura</div>
            <div
              style={{ fontSize: "16px", color: "#222222", fontWeight: "bold" }}
            >
              {master.width}px
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "30px",
              fontSize: "14px",
            }}
          >
            <div style={{ fontSize: "16px", color: "#707070" }}>Altura</div>
            <div
              style={{ fontSize: "16px", color: "#222222", fontWeight: "bold" }}
            >
              {master.height}px
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "30px",
              fontSize: "14px",
            }}
          >
            <div style={{ fontSize: "16px", color: "#707070" }}>Tamanho</div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "30px",
                margin: "0 0 0 60px",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  margin: "0 0 0 0",
                  cursor: "pointer",
                }}
                onClick={() => MinMaxOptimize(100)}
              >
                ↑
              </div>
              <div
                style={{
                  fontSize: "18px",
                  margin: "0 0 0 0",
                  cursor: "pointer",
                }}
                onClick={() => MinMaxOptimize(10)}
              >
                ↓
              </div>
            </div>
            <input
              style={{
                border: "none",
                borderRadius: "5px",
                fontWeight: "bold",
                fontSize: "16px",
                width: "70px",
                textAlign: "center",
                height: "30px",
                padding: "0 0px 2px 0px",
                margin: "-5px 0 0 5px",
              }}
              maxLength={3}
              className="propertiesWeightInput"
              type="number"
              value={newKbValue}
              placeholder={master.size + "kb"}
              onChange={(event) =>
                setNewKbValue(event.target.value.slice(0, 3))
              }
              onKeyDown={handleKeyDown}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "30px",
              fontSize: "14px",
              margin: "5px 0 5px 0",
            }}
          >
            <div style={{ fontSize: "16px", color: "#707070" }}>Qualidade</div>
            <select
              value={selectedValue}
              onChange={handleSelectChange}
              style={{
                border: "none",
                borderRadius: "5px",
                fontWeight: "bold",
                fontSize: "16px",
                width: "70px",
                height: "30px",
                padding: "0 0 2px 5px",
                margin: "-5px 0 0 0",
              }}
            >
              <option value="100">100%</option>
              <option value="90">90%</option>
              <option value="80">80%</option>
              <option value="70">70%</option>
              <option value="60">60%</option>
              <option value="50">50%</option>
              <option value="40">40%</option>
              <option value="30">30%</option>
              <option value="20">20%</option>
              <option value="10">10%</option>
            </select>
          </div>

          <Divider className="propertiesDividerInside" />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "middle",
              margin: "5px 0 0 0",
              height: "30px",
            }}
          >
            <div style={{ verticalAlign: "center", display: "block" }}>
              <p
                style={{
                  color: "#707070",
                  verticalAlign: "center",
                  margin: "auto",
                  fontWeight: "normal",
                }}
              >
                Cor de fundo{" "}
              </p>
            </div>
            <div
              onClick={() => openCloseColorPick()}
              style={{
                margin: "auto 11px ",
                cursor: "pointer",
                backgroundColor: `${blockPickerColor}`,
                width: 20,
                height: 20,
                borderRadius: "4px",
                border: "0.5px solid white",
              }}
            ></div>
          </div>

          <div
            style={{
              display: openColor === false ? "none" : "flex",
              zIndex: "999 !important",
              margin: " 1.2rem auto 1rem auto",
              flexDirection: "column",
            }}
          >
            <div
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  changeBackground(blockPickerColor);
                  setOpenColor(false);
                }
              }}
              style={{ justifyContent: "center", margin: "0 auto" }}
            >
              <ChromePicker
                color={blockPickerColor}
                onChangeComplete={(color) => {
                  setBlockPickerColor(color.hex);
                }}
                disableAlpha={true}
              />
            </div>

            <div style={{ margin: "0 auto" }}>
              <button
                onClick={() =>
                  changeBackground(blockPickerColor) & setOpenColor(false)
                }
                className="apply-color"
              >
                Aplicar Cor
              </button>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "4px",
            }}
          >
            <div
              style={{
                verticalAlign: "center",
                margn: "auto",
                display: "block",
              }}
            >
              <p
                style={{
                  color: "#707070",
                  verticalAlign: "center",
                  margn: "auto",
                  fontWeight: "normal",
                }}
              >
                Borda
              </p>
            </div>
            <button
              className="changeBorderBtn"
              onClick={() => addOrRemoveBorder(border)}
            >
              {currentBorder === "NONE" ? " Adicionar" : "Remover"}
            </button>
          </div>

          <div className="backupFormat">            
            <p>Backup: </p>
            <select
              style={{ width: '100px', marginLeft: '10px', padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc' }}
              defaultValue={backupFormat}
              onChange={e => setBackupFormat(e.target.options[e.target.selectedIndex].text)}
            >
              {['png', 'jpg', 'webp'].map((image, idx) => (
                <option key={idx}>
                  {image}
                </option>
              ))}
            </select>

              
            {/* <span>
              <p>png</p>
              <button
            className={`${backupFormat === 'png' ? 'btnSwitchPNG' : 'btnSwitchJPG'}`}
            type="button"
            onClick={() =>setBackupFormat(backupFormat === "png" ? "jpg" : "png")}
          >
            <span></span>
          </button>
              <p>jpg</p>
            </span> */}
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default Properties;
